import { RestApi } from "../services/rest-api";

export interface AccountTrialBalanceModel {
  ac_id: number;
  ac_name: string;
  amt: number;
  credit: number;
  debit: number;
  gp_name: string;
}

export interface AccountTrialSummaryModel {
  opening_diff: number;
  trial_diff: number;
  credit: number;
  debit: number;
  amt: number;
}

export interface AccountLedgerModel {
  ac_id: number;
  bilty_no: string;
  amt: number;
  credit: number;
  debit: number;
  balance: number;
  due_days: number;
  mark_paid: string;
  narration: string;
  remarks: string;
  v_date: string;
  v_id: string;
  v_type: string;
  vt_type: string;
}


export const fetctAccountTrialBalance = async (searchParams: any, authInfo: any) => {
  return await RestApi<{ trialBalanceList: Array<AccountTrialBalanceModel>, openingDifference: number }>('post', 'accountTrialBalance', searchParams, authInfo.user.authorization).then(function (response) {
    return { data: response.trialBalanceList, openingDifference: response.openingDifference };
  });
};

export const fetctAccountLedger = async (searchParams: any, authInfo: any) => {
  return await RestApi<Array<AccountLedgerModel>>('post', 'accountLedger', searchParams, authInfo.user.authorization).then(function (response) {
    return { data: response };
  });
};

export const fetctAgentAccountTrialBalance = async (searchParams: any, authInfo: any) => {
  return await RestApi<Record<string, Array<AccountTrialBalanceModel>>>('post', 'agentAccountTrialBalance', searchParams, authInfo.user.authorization).then(function (response) {
    return { data: response };
  });
};
